import * as React from "react"
const Puzzle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={43}
    height={44}
    fill="none"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={3.177}
      d="M34.577 14.601a1.808 1.808 0 0 0 .51 1.55l2.767 2.767a4.242 4.242 0 0 1 1.246 3.007 4.237 4.237 0 0 1-1.246 3.008l-2.843 2.843a1.73 1.73 0 0 1-1.477.487c-.83-.123-1.416-.847-1.709-1.633a4.414 4.414 0 1 0-5.672 5.673c.787.293 1.51.877 1.633 1.708a1.727 1.727 0 0 1-.488 1.477l-2.84 2.842a4.241 4.241 0 0 1-3.01 1.248 4.24 4.24 0 0 1-3.007-1.246l-2.768-2.768a1.81 1.81 0 0 0-1.547-.511c-.87.13-1.483.889-1.8 1.708a4.412 4.412 0 1 1-5.714-5.713c.82-.318 1.578-.93 1.707-1.8a1.81 1.81 0 0 0-.51-1.548l-2.767-2.767a4.24 4.24 0 0 1-1.246-3.008c0-1.089.416-2.178 1.246-3.007l2.693-2.693a1.897 1.897 0 0 1 1.618-.535c.91.136 1.548.932 1.894 1.783a4.412 4.412 0 1 0 5.752-5.752c-.85-.346-1.647-.985-1.783-1.894a1.894 1.894 0 0 1 .535-1.618l2.691-2.692a4.24 4.24 0 0 1 3.006-1.244c1.089 0 2.178.417 3.007 1.246l2.768 2.767c.406.406.98.597 1.547.512.87-.13 1.483-.89 1.8-1.708a4.412 4.412 0 1 1 5.713 5.713c-.818.317-1.577.928-1.706 1.798Z"
    />
  </svg>
)
export default Puzzle